import ReactGA from 'react-ga'

export const TrackEvent = data => {
  ReactGA.event({ ...data })
}
